var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-field-wrapper"},[_c('app-field-label',{attrs:{"forAttribute":_vm.componentId,"text":_vm.localLabel}}),_c('b-form-input',{attrs:{"id":_vm.componentId,"placeholder":_vm.localPlaceholder,"trim":"","value":_vm.localValue},on:{"input":_vm.onChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }